var React = require('react');

function ArrowBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"cls-1","d":"M12.94,17.62.17,0H25.71ZM6.3,3.13l6.64,9.16,6.64-9.16Z","transform":"translate(-0.17)"}));
}

ArrowBottom.defaultProps = {"id":"Capa_1","data-name":"Capa 1","viewBox":"0 0 25.55 17.62"};

module.exports = ArrowBottom;

ArrowBottom.default = ArrowBottom;
